import { HttpClient } from '../api/httpclient.service';

export interface QuestionAnswer {
  question_type_id: number;
  question_text: string;
  answer_text: string;
}

export interface BookGenerationRequest {
  character_name: string;
  character_gender: number;
  character_age: number;
  character_eye_color: string;
  character_has_glass: boolean;
  character_hair_color: string;
  character_hair_style: string;
  illustration_style: string;
  story_type: string;
  story_spirit: string;
  story_tone: string;
  user_display_name: string;
  dedication?: string;
  questions_answers?: QuestionAnswer[];
  image_provider?: 'flux' | 'nano';
}

export interface GetUserBooksRequest {
  user_id: number;
}

export interface UserBookInfo {
  id: string;
  name: string;
  url: string;
}

export interface GetUserBooksResponse {
  books: Record<string, UserBookInfo>;
}

export class BookService extends HttpClient {
  constructor() {
    super();
  }

  async generateBook(payload: BookGenerationRequest | FormData): Promise<any> {
    try {
      if (payload instanceof FormData) {
        const response = await this.post('/books/generate_book', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        return response;
      } else {
        const response = await this.post('/books/generate_book', payload);
        return response;
      }
    } catch (error) {
      console.error('Error generating book:', error);
      throw error;
    }
  }

  async getBookContent(bookId: number): Promise<any> {
    try {
      const payload = { book_id: bookId };
      const response = await this.post('/books/get_book_content', payload);
      return response;
    } catch (error) {
      console.error('Error getting book content:', error);
      throw error;
    }
  }

  async getUserBooks(userId: number): Promise<GetUserBooksResponse> {
    try {
      const payload = { user_id: userId };
      const response = await this.post('/books/get_user_existing_books', payload);
      return response;
    } catch (error) {
      console.error('Error getting user books:', error);
      throw error;
    }
  }

  async getBookContentByHashedId(hashedBookId: string): Promise<any> {
    try {
      const response = await this.get(`/books/get_book_content_by_hashedid/${hashedBookId}`);
      return response;
    } catch (error) {
      console.error('Error getting book content by hashed ID:', error);
      throw error;
    }
  }
}
